import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CloudDownload, ErrorOutline, Print } from "@mui/icons-material";
import { Box, Button, Card, FormLabel, Grid, Icon, MenuItem, TextField, styled } from "@mui/material";
import { Loader } from "app/components";
import { getAllProjectLocationListForBill } from "app/redux/actions/RABillActions";
import { getAllRaBillNoForReport, getRunningAccountBillDomReport, getRunningAccountBillForReport } from "app/redux/actions/ReportsAction";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { checkValidation, currencyFormat, formatNumberWithCommasAndDecimals, getTwoDigitDecimal } from "app/utils/utils";
import { SimpleCard } from "components";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { useSnackbar } from "notistack";
import { Fragment, useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";


const styles = {
  tableCell: {
    textAlign: "center"
  },
  subHeader: {
    textAlign: "center",
    fontWeight: 700
  }

}
const DecoratedTextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
}));




export const RABillDomReport = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [projectDetails, setProjectDetails] = useState()
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const { projectLocationList } = useSelector((state) => state.raBill);
  const [raBillList, setRaBillList] = useState([])

  const [tableData, setTableData] = useState()
  const [grandTotal, setGrandTotal] = useState()

  const [state, setState] = useState({
    project_location_id: '',
    ra_bill_id: ""
  })


  useEffect(() => {
    dispatch(getAllProjectLocationListForBill(showLoader, hideLoader, showToast))
  }, []);
  const showLoader = () => {
    setLoading(true)
  }
  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  const hideLoader = () => {
    setLoading(false)
  }
  const handleChange = (event, source) => {
    setTableData()

    if (event.target.name === "project_location_id") {
      setRaBillList([])
      const filteredArray = projectLocationList.filter(project => {
        return project.project_location_id === event.target.value
      });
      state.project_name = filteredArray[0].project_name
      state.project_location_id = filteredArray[0].project_location_id
      state.project_id = filteredArray[0].project_id
      setLoading(true)
      setState({ ...state, [event.target.name]: event.target.value, ra_bill_id: "" });
      getAllRaBillNoForReport({ project_location_id: filteredArray[0].project_location_id }).then(res => {
        setLoading(false)
        if (res?.status < 300) {
          if (res?.data?.obj?.rabill_details?.length > 0) {
            setRaBillList(res?.data?.obj?.rabill_details)
          }

        } else {
          const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        }
      }).catch(error => {
        setLoading(false)
        const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
        SnackBarProperty.error(key, closeSnackbar);

      })
    } else {
      const filteredArray = raBillList.filter(raBill => {
        return raBill.runningaccountbill_id === parseInt(event.target.value)
      })
      setState({ ...state, [event.target.name]: parseInt(event.target.value), "rabill_no": filteredArray[0].rabill_no });
    }
  }


  const handleFormSubmit = async () => {
    if (!checkValidation(state?.project_location_id)) {
      const key = enqueueSnackbar("Please select project location", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }
    else if (!checkValidation(state?.ra_bill_id)) {
      const key = enqueueSnackbar("Please select RA Bill No.", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    }
    else {
      setLoading(true)
      setTableData()

      getRunningAccountBillDomReport({ project_location_id: state?.project_location_id, ra_bill_id: state?.ra_bill_id })
        .then((res) => {
          setLoading(false)
          console.log("response:", res)
          if (res?.status < 300 && res?.data?.success && res?.data?.obj && res?.data?.obj?.item) {
                console.log("table data is", res?.data?.obj)
                setTableData(res?.data?.obj?.item)
                setProjectDetails({
                  project_id: state?.project_id,
                  project_name: state?.project_name,
                  rabill_no: state?.rabill_no,
                  header: res?.data?.obj?.header_logo,
                  footer: res?.data?.obj?.footer_logo
                })
          }
          else{
            const key = enqueueSnackbar(res?.data?.message, { variant: 'info' });
            SnackBarProperty.info(key, closeSnackbar);
          }
        }).catch(error => {
          setLoading(false)
          const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);

        })

    }
  }

  const handleReportDownload = (isPrint) => {
    if (isPrint) {
      setIsPrinting(true)
      setIsDownloading(false)
    }
    else {
      setIsPrinting(false)
      setIsDownloading(true)
    }
      const doc = new jsPDF();
      const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
      const textX = 15;
      const textY = headerHeight

      // Add the text content below the header image
      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setFontSize(12); // Set font size
      doc.text("RUNNING ACCOUNT BILL DOM", (doc.internal.pageSize.getWidth() / 2) - ((doc.getStringUnitWidth("RUNNING ACCOUNT BILL") * doc.internal.getFontSize() / doc.internal.scaleFactor) / 2), textY);
      
      const textWidth = doc.getStringUnitWidth("Contract Amount:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      
      doc.setFontSize(8); // Set font size
      doc.text("Project Name:", textX, textY + 10);
      doc.setFont('helvetica', 'normal');
      doc.text(projectDetails?.project_name, textX + textWidth + 5, textY + 10);
    //   doc.setFont('helvetica', 'bold');
    //   doc.text("Client:", textX, textY + 15);
    //   doc.setFont('helvetica', 'normal');
    //   doc.text(projectDetails?.client, textX + textWidth + 5, textY + 15);
      doc.setFont('helvetica', 'bold');
      doc.text("Project ID:", textX, textY + 15);
      doc.setFont('helvetica', 'normal');
      doc.text(`${projectDetails?.project_id}`, textX + textWidth + 5, textY + 15);
      doc.setFont('helvetica', 'normal');

      //   doc.setFont('helvetica', 'bold');
      //   doc.text("End Date:",textX, textY + 15);
      //   const fourthTextWidth = doc.getStringUnitWidth("End Date:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      //   doc.setFont('helvetica', 'normal');
      //   doc.text(`${moment(contractDetails?.work_end_date).format("DD-MM-YYYY")}`, textX + fourthTextWidth + 5, textY+15);
      //   doc.setFont('helvetica', 'normal');
      doc.setFont('helvetica', 'bold');
      doc.text("RA Bill No.:", textX, textY + 20);
      doc.setFont('helvetica', 'normal');
      doc.text(`${projectDetails?.rabill_no}`, textX + textWidth + 5, textY + 20);
    //   doc.setFont('helvetica', 'bold');
    //   doc.text("Contract Amount:", textX, textY + 30);
    //   doc.setFont('helvetica', 'normal');
    //   doc.text(`${getTwoDigitDecimal(projectDetails?.contract_amount)}`, textX + textWidth + 5, textY + 30);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(5);

      const headerSectionHeight = headerHeight+35; // Adjust the value as needed
      // Calculate the starting Y-coordinate for the table
        const tableStartY = headerSectionHeight + 5;

      doc.setFont('helvetica', 'normal');

      function transformData(data) {
            const body = [];
            data?.forEach((construction) => {

            // Construction row
            body.push([
                { content: "Construction type: " + construction?.constructiontype_name, colSpan: 7, styles: { fontStyle: "bold" } }
            ])
            body.push([
                { content: "Construction Name: " + construction?.construction_name, colSpan: 7, styles: { fontStyle: "bold" } }
            ])
            body.push([
                { content: "Name: " + construction?.boq_name, colSpan: 7, styles: { fontStyle: "bold" } }
            ])

            construction?.stages?.forEach((stage) => {

                // Stage row
                body.push([
                { content: "Stage Name: " + stage?.stage_name, colSpan: 7, styles: { fontStyle: "bold" } }
                ])

                stage?.items?.forEach((item) => {

                // Item row
                body.push([
                    { content: "Item code: " + item?.item_code, colSpan: 7, styles: { fontStyle: "bold" } }
                ])

                // DOM rows
                item?.children?.forEach((dom, dIndex) => {

                    body.push([
                    { content: currencyFormat(dIndex + 1) },
                    { content: currencyFormat(dom?.item_no) },
                    { content: currencyFormat(dom?.length) },
                    { content: currencyFormat(dom?.breadth) },
                    { content: currencyFormat(dom?.height) },
                    { content: dom?.item_sign ?? "+" },
                    // { content: currencyFormat(dom?.quantity) },
                    { content: dom?.remarks ?? "" }
                    ])

                })

                body.push([
                    {
                        content: "Total Quantity:",
                        colSpan: 6,
                        styles: { fontStyle: "bold", halign: "right" }
                    },
                    {
                        content: currencyFormat(item?.quantity),
                        colSpan: 1
                    }
                    ])
                })
            })
        })
         return body;
        }
        
            const transformedData = transformData(tableData);
            

            doc.autoTable({
                margin: { 
                top: 30,      // push below header
                bottom: 30    // leave space above footer
            },
            startY: tableStartY,
            head: [[
                { content: "Sl. No.", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
                { content: "No", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
                { content: "Length", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
                { content: "Breadth", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
                { content: "Height", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
                { content: "Deductions", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
                // { content: "QUANTITY", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
                { content: "Remarks", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } }

            ]],
            body: transformedData, // Use the transformed data here
            theme: "grid",
            styles: {
                fillColor: [255, 255, 255], // Remove background color from the table
                lineColor: [0, 0, 0], // Set border color for main table
                lineWidth: 0.1, // Set border width for main table
                textColor: [0, 0, 0], // Set text color to black
                cellPadding: 2, // Add padding to cells
            },
            columnStyles: {
                2: { cellWidth: 50 }, // "ITEM DESCRIPTION" column width
                5: { halign: "right" }, // "RATE" column width
                6: { halign: "right" }, // "AMOUNT" column width
                3: { halign: "right" }, // "UNIT" column width
            },
            });

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Get last table Y position
        const lastY = doc.lastAutoTable?.finalY || 0;

        // Required space for signature block
        const requiredSpace = 40;

        // Decide: same page or new page
        if (lastY + requiredSpace > pageHeight) {
          doc.addPage(); // ✅ create new page
        }

        // Go to last page again
        const lastPage = doc.getNumberOfPages();
        doc.setPage(lastPage);

        // Set Y position safely
        let y = doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : 30;

        // If new page, reset Y
        if (y + requiredSpace > pageHeight) {
          y = 30;
        }

        // Title
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text("Joint Measurement taken by:", 15, y);

        y += 20;

        // Signature lines
        doc.line(pageWidth * 0.15, y, pageWidth * 0.35, y); // Contractor
        doc.line(pageWidth * 0.65, y, pageWidth * 0.85, y); // Client

        y += 8;

        // Labels
        doc.text("(Contractor)", pageWidth * 0.25, y, { align: "center" });
        doc.text("(Client)", pageWidth * 0.75, y, { align: "center" });

        const totalNumPages = doc.internal.getNumberOfPages();

        // Loop through each page to add the footer with page numbers
        for (let i = 1; i <= totalNumPages; i++) {

            const pdfWidth = doc.internal.pageSize.getWidth() - 30;

            // Header
            const headerHeight = 20;
            const headerX = 15;
            const headerY = 0; // at the very top
            if (checkValidation(projectDetails?.header)) {
            doc.addImage(
                `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
                headerX,
                headerY,
                pdfWidth,
                headerHeight
            );
            }

            //Footer
            const footerX = 15; // Starting X position for the footer
            const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
            const footerHeight = 20;
            doc.setPage(i);
            if (checkValidation(projectDetails?.footer)) {
              doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
            }
        }

            const scaleFactor = 1.0; // Adjust this value as needed
            const pdfBlob = doc.output('blob', { scale: scaleFactor });

            // Create a URL for the Blob
            const pdfUrl = URL.createObjectURL(pdfBlob);

            // Open a new window with the PDF URL

            if (isPrint) {
            const newWindow = window.open(pdfUrl, '_blank');

            // After the new window is opened, you can close the URL object
            URL.revokeObjectURL(pdfUrl);
            if (newWindow) {
                newWindow.onload = () => {
                setIsPrinting(false)
                setIsDownloading(false)
                // Wait for the window to load and then trigger the print dialog
                newWindow.print();
                };
            }
            }

            setIsPrinting(false)
            setIsDownloading(false)

            isPrint === false && doc.save('RABill_DOM_Report.pdf');
  };

  return (
    <>
      <div style={{ height: 'auto', width: "100%", padding: '30px', display: "flex", flexDirection: "column", gap: "20px" }}>

        <Grid container>

          <Grid item xs={12}>
            <Button
              size="small"
              sx={{ width: "100px" }}
              variant="contained"
              color="error"
              onClick={() => { window.history.back() }}
            >
              <Icon color="primary" fontSize="small">
                skip_previous
              </Icon>
              Back
            </Button>
          </Grid>
        </Grid>
        <SimpleCard>
          <ValidatorForm onSubmit={handleFormSubmit}>
            <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
              <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Running Account Bill DOM</b></Grid>
            </Grid>
            <Grid container spacing={3} >

              <Grid item sm={4} xs={12}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="Project ID"
                  id="project_location_id"
                  variant="outlined"
                  name="project_location_id"
                  value={state?.project_location_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Project ID is required"]}
                >
                  {projectLocationList?.map((item) => (
                    <MenuItem value={item?.project_location_id} key={item?.project_id}>
                      {item?.project_id}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={4} xs={12}>
                <TextField
                  select
                  size="small"
                  fullWidth
                  sx={{ mb: 3 }}
                  label="RA Bill No."
                  id="rabill_id"
                  variant="outlined"
                  name="ra_bill_id"
                  value={state?.ra_bill_id}
                  onChange={handleChange}
                  validators={["required"]}
                  errorMessages={["Project ID is required"]}
                >
                  {raBillList?.map((item) => (
                    <MenuItem value={item?.runningaccountbill_id} key={item?.runningaccountbill_id}>
                      {item?.rabill_no}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item sm={4} xs={12}>


                <Button size="medium" color="success" variant="contained" type="submit" style={{ marginLeft: 4 }} >View</Button>

              </Grid>

            </Grid>

          </ValidatorForm>
        </SimpleCard>
        {
          tableData && tableData?.length > 0 &&
          <Grid container>
            <Grid xs={12} md={6}>
              {/* {checkValidation(projectDetails?.header) === false && <FormLabel sx={{ color: "#ff9800" }} color="warning">! Please upload header and footer for download/print</FormLabel>} */}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="span" display="flex" justifyContent="flex-end">
                <Button
                  size="small"
                  sx={{ width: "130px", marginLeft: 4 }}
                  variant="contained"
                  color="warning"
                  // disabled={projectDetails?.header ? false : true}
                  startIcon={<CloudDownload />}
                  onClick={() => { handleReportDownload(false) }}
                >
                  Download
                </Button>
                <Button
                  size="small"
                  sx={{ width: "100px", marginLeft: 2 }}
                  variant="contained"
                  color="primary"
                  // disabled={projectDetails?.header ? false : true}
                  startIcon={<Print />}
                  onClick={() => { handleReportDownload(true) }}
                >
                  Print
                </Button>
              </Box>
            </Grid>

          </Grid>}

        {
          tableData && tableData?.length > 0 && projectDetails &&
          <Card sx={{ padding: 3 }}>
            <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
              <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px", paddingLeft: "100px", paddingRight: "100px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
                  {checkValidation(projectDetails?.header) && 
                  <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "150px", width: "auto" }} alt="img" />
                  }
                </div>
              </div>

              <Grid container >
                <Grid item xs={12} sx={{ marginTop: 2, textAlign: "center" }}>
                  <FormLabel sx={{ fontSize: 20 }}><b>RUNNING ACCOUNT BILL DOM</b></FormLabel>
                </Grid>
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{projectDetails?.project_name}</FormLabel>
                </Grid>
                {/* <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Client: </b>{projectDetails?.client}</FormLabel>
                </Grid> */}
                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project ID: </b>{projectDetails?.project_id}</FormLabel>
                </Grid>
                {/* <Grid item  xs={12} sx={{marginTop:2}}>
                <FormLabel sx={{fontSize:18}}><b>Start Date.: </b>{moment(contractDetails?.work_start_date).format("DD-MM-YYY")}</FormLabel>
                </Grid>
                <Grid item  xs={12} sx={{marginTop:2}}>
                    <FormLabel sx={{fontSize:18}}><b>End Date.: </b>{moment(contractDetails?.work_end_date).format("DD-MM-YYY")}</FormLabel>
                </Grid> */}

                {/* <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Contract Amount: </b>{formatNumberWithCommasAndDecimals(parseFloat(projectDetails?.contract_amount ?? 0).toFixed(2))}</FormLabel>
                </Grid> */}

                <Grid item xs={12} sx={{ marginTop: 2, marginBottom: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>RA Bill No.: </b>{projectDetails?.rabill_no}</FormLabel>
                </Grid>
              </Grid>
            </div>

            <div id="tableData">
                <TableContainer component={Paper}>
                    <Table>
                    <TableHead style={{ backgroundColor: '#87CEEB' }}>
                        <TableRow>
                         <TableCell align="right">Sl. No.</TableCell>
                        <TableCell align="right">No</TableCell>
                        <TableCell align="right">Length</TableCell>
                        <TableCell align="right">Breadth</TableCell>
                        <TableCell align="right">Height</TableCell>
                        <TableCell align="center">Deductions</TableCell>
                        <TableCell>Remarks</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

{tableData?.map((construction, cIndex) => (

  <Fragment key={cIndex}>

    <TableRow>
      <TableCell colSpan={7} style={{ background: "#f5f5f5" }}>
        <b>Construction type:</b> {construction.constructiontype_name}
      </TableCell>
    </TableRow>

    <TableRow>
      <TableCell colSpan={7} style={{ background: "#f5f5f5" }}>
        <b>Construction Name:</b> {construction.construction_name}
      </TableCell>
    </TableRow>

    <TableRow>
      <TableCell colSpan={7} style={{ background: "#f5f5f5" }}>
        <b>Name:</b> {construction.boq_name}
      </TableCell>
    </TableRow>

    {construction?.stages?.map((stage, sIndex) => (

      <Fragment key={sIndex}>

        {/* Stage Row */}
        <TableRow>
          <TableCell colSpan={7} style={{ paddingLeft: 20 }}>
            <b>Stage: </b>{stage.stage_name}
          </TableCell>
        </TableRow>

        {stage?.items?.map((item, iIndex) => (

          <Fragment key={iIndex}>

            {/* Item Row */}
            <TableRow>
              <TableCell colSpan={7} style={{ paddingLeft: 20 }}><b>Item code: </b>{item.item_code}</TableCell>
            </TableRow>

            {/* DOM rows */}
            {item?.children?.map((dom, dIndex) => (

              <TableRow key={dIndex}>
                <TableCell align="right">{dIndex + 1}</TableCell>
                <TableCell align="right">{currencyFormat(dom?.item_no)}</TableCell>
                <TableCell align="right">{currencyFormat(dom?.length)}</TableCell>
                <TableCell align="right">{currencyFormat(dom?.breadth)}</TableCell>
                <TableCell align="right">{currencyFormat(dom?.height)}</TableCell>
                <TableCell align="center">{dom?.item_sign ?? "+"}</TableCell>
                {/* <TableCell align="right">{currencyFormat(dom?.quantity)}</TableCell> */}
                <TableCell>{dom?.remarks}</TableCell>

              </TableRow>

            ))}

            <TableRow>
              <TableCell align="right" colSpan={7} style={{ paddingLeft: 20 }}>
                <b>Total Quantity:</b> {currencyFormat(item?.quantity)}
              </TableCell>
            </TableRow>

          </Fragment>

        ))}

      </Fragment>

    ))}

  </Fragment>

))}

</TableBody>
  </Table>
</TableContainer>
  </div>
  </Card>
  }

      </div>
      {loading && (
        <Loader
          show={loading}
        />
      )}
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please wait."
        />
      )}

    </>
  )
}